// FolderManagement.js
import React, { useEffect, useMemo, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import {
  Box,
  Button,
  Divider,
  FormGroup,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from "@mui/material";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import { ThemeColor } from "../../component/theme/color";
import CustomButton from "../../component/button/button";
import "../foldermanagement/foldermanagement.css";
import FolderMenu from "../../Icon/FolderMenu";
import FolderShare from "../../Icon/FolderShare";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FolderStackAction,
  GetFileAction,
  GetFolderAction,
} from "../../Redux/action/FileManagerAction";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import {
  CreateFolderService,
  DeleteFileService,
  DeleteFolderService,
  UpdateFileService,
  UpdateFolderService,
} from "../../Redux/service/FileManagerService";
import { AddCircleOutlined, Check, Close, FolderRounded, Share } from "@mui/icons-material";
import { Form, Formik } from "formik";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import Crossicon from "../../Icon/Crossicon";
import * as Yup from "yup";
import { RightOutlined } from "@ant-design/icons";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import { CreateFileModal } from "./CreateFileModal.component";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { downloadFile } from "./fileDownload.util";
import MoveToModal from "./MoveToModal.component";
import { getFileIcon } from "./fileIcon.util";
import FolderBreadcrumbs from "./FolderBreadcrumbs.component";
import SnackbarComponent from "../../component/snackbar/snackbar";
import {
  FileManagerNoResult,
  FileManagerSearch,
  useFileManagerSearch,
} from "./FileManagerSearch.component";

// A constant type for drag-and-drop items
const ItemTypes = {
  FILE: "file",
  FOLDER: "folder",
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "94%", sm: 460, md: 500 },
  maxWidth: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 24px 60px rgba(16, 24, 40, 0.22)",
  p: { xs: 2.5, sm: 3 },
  outline: "none",
};


// Folder component
const Folder = ({
  folder,
  onDrop,
  onClick,
  moveFolder,
  handleFolderActionFromChild,
  handleDelete,
}) => {
  const navigate = useNavigate();
  const disptach = useDispatch();
  const [folderstack, setFolderstack] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [renameOn, setRenameOn] = useState("none");
  const [copied, setCopied] = useState(false);
  const [moveOpen, setMoveOpen] = useState(false);
  const isAdmin = window?.sessionStorage.getItem("user_role_type") === "admin";

  // const FolderStackState = useSelector(
  //   (state) => state.fileManager?.folderstack
  // );
  // //("stack of the folder", FolderStackState);
  // useEffect(() => {
  //   setFolderstack(FolderStackState);
  // }, [FolderStackState]);

  const [{ isOver }, drop] = useDrop({
    accept: [ItemTypes.FILE, ItemTypes.FOLDER],
    drop: (item) => {
      //(item, "inside the drop of folder");
      // if (item.type === ItemTypes.FOLDER) {
      //   moveFolder(item.id, folder.id); // Handle moving folders
      // } else {
      //   onDrop(item, folder.id); // Handle file drop
      // }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FOLDER,
    item: { id: folder.id, type: ItemTypes.FOLDER },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const dragDropRef = (node) => {
    drag(node); // Assign drag ref
    drop(node); // Assign drop ref
  };

  const handleRename = async () => {
    setRenameOn("flex");
  };

  const updateFileSchema = Yup.object().shape({
    name: Yup.string().required("Name of file is required."),
  });

  const handleCopyUrl = async (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    try {
      // Get the direct folder URL
      const folderUrl = `${window.location.origin}/CAE/FileManager/Folder/${folder.id}`;

      // Write the URL string to the clipboard
      await navigator.clipboard.writeText(folderUrl);

      // Update state to show feedback
      setCopied(true);
      // Show snackbar to notify user
      disptach(showSnackbar("Link copied to clipboard", "success"));
      // Reset feedback text after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy URL: ', err);
      disptach(showSnackbar("Failed to copy link", "error"));
    }
  };

  return (
    <div
      //   ref={drag}
      ref={dragDropRef}
      className="fm-row"
      style={{
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: isOver ? "#e8f7ec" : "",
      }}
      // onClick={() => onClick(folder)}
    >
      <Box className="file" onClick={(e) => e.stopPropagation()}>
        <div className="w-100 d-flex">
          <div className="filename-icon" style={{ width: "25px", height: "25px" }}>
            <img
              src="/assest/folderpng/folder.png"
              alt="file icon"
              className="w-100 h-100"
            ></img>
          </div>
          <div className="file-name px-2 w-100">
            <Typography
              onClick={() => {
                if (folder.isLocked && !isAdmin) {
                  disptach(
                    showSnackbar(
                      "This folder is locked right now by admin please contact to admin",
                      "error"
                    )
                  );
                  return;
                }
                onClick(folder);
              }}
              sx={{ display: renameOn === "none" ? "flex" : "none" }}
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W500}
              fontSize={fontSize.h3.medium}
            >
              {folder.name}
            </Typography>
           
            <Box
              sx={{ display: renameOn === "none" ? "none" : "flex" }}
              className="w-100"
            >
              <Formik
                initialValues={{
                  name: folder ? folder.name : "",
                }}
                validationSchema={updateFileSchema}
                className="w-100"
                onSubmit={async (values) => {
                  //(values, "agent payload");
                  await UpdateFolderService(values, folder.id)
                    .then((res) => {
                      //(res);
                      if (res.status === 200) {
                        //(res);
                        handleFolderActionFromChild();

                        disptach(showSnackbar(res.data.message, "success"));
                        setRenameOn("none");
                      }
                    })
                    .catch((e) => {
                      disptach(showSnackbar(apiErrorMessage(e), "error"));
                    });
                }}
              >
                {({
                  values,
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  handleSubmit,
                  setFieldValue,
                  resetForm,
                }) => (
                  <Form className="w-100" onSubmit={handleSubmit}>
                    <Grid container spacing={2} className="">
                      <Grid item lg={6} xs={6}>
                        <div className="">
                          <OutlinedInputField
                            value={values.name}
                            name={"name"}
                            onChange={handleChange}
                            placeholder="Update file name"
                            fullWidth={true}
                            onBlur={handleBlur}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.name}
                              </Typography>
                            }
                          />
                        </div>
                      </Grid>
                      <Grid item lg={6} xs={6}>
                        <Box
                          sx={{
                            flexDirection: {
                              lg: "row",
                              md: "row",
                              sm: "column",
                              xs: "column",
                            },
                          }}
                          className=""
                        >
                          <IconButton type="submit">
                            <Check sx={{ fill: ThemeColor.BLUE }} />
                          </IconButton>
                          <IconButton>
                            <Close
                              sx={{ fill: "red" }}
                              onClick={() => {
                                setRenameOn("none");
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      </Box>

      <Box className="file-action">
        <div className="w-100 d-flex align-items-center justify-content-end">
          <div className="file-action-content d-flex">
            {!folder.isLocked && <div className="px-2 fm-menu-btn" title="More options">
              <IconButton
                sx={{ padding: 0 }}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <FolderMenu />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem onClick={handleRename}>Rename</MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    setMoveOpen(true);
                  }}
                >
                  Move to...
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    handleDelete("folder", folder.id);
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
              <MoveToModal
                open={moveOpen}
                handleClose={() => setMoveOpen(false)}
                item={{ id: folder.id, name: folder.name, type: "folder" }}
                onMoved={handleFolderActionFromChild}
              />
            </div>}
                {window?.sessionStorage.getItem("user_role_type") ===
                  "admin" && (
                  <div
                    className="px-2 mt-2"
                    title={folder.isLocked ? "Unlock folder" : "Lock folder"}
                  >
                          <span
                            sx={{}}
                            onClick={async () => {
                              console.log(folder, "status of the lock");
                              // handle lock and un lock button
                              await UpdateFolderService({ isLocked: !folder.isLocked }, folder.id)
                                .then((res) => {
                                  //(res);
                                  if (res.status === 200) {
                                    //(res);
                                    handleFolderActionFromChild();
                                    disptach(showSnackbar(res.data.message, "success"));
                                  }
                                })
                                .catch((e) => {
                                  disptach(showSnackbar(apiErrorMessage(e), "error"));
                                });
                            }}
                          >
                            {
                              folder.isLocked==true ? (<img src={"/assest/lock.svg"} height="20" width="20" />) : (
                                <img src={"/assest/unlock.svg"} height="20" width="20" />
                              )
                            }
                          </span>
                        </div>
                )}
            {(!folder.isLocked || isAdmin) && (
              <div
                className="px-2 mt-2"
                title="Copy link"
                onClick={handleCopyUrl}
              >
                <Share fontSize="small" />
              </div>
            )}
          </div>

          <div className="file-action-date d-flex">
            <Typography
              fontFamily={FontFamily.Poppins}
              fontSize={fontSize.h3.small}
              fontWeight={fontWeight.W500}
              color={ThemeColor.GREY}
            >
              {/* Creation date of this folder, not today. */}
              {folder.createdAt
                ? dayjs(folder.createdAt).format("DD/MM/YYYY")
                : "-"}
            </Typography>
          </div>
        </div>
      </Box>
    </div>
  );
};

// File component
const File = ({ file, handleFolderActionFromChild, handleDelete }) => {
  const disptach = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [renameOn, setRenameOn] = useState("none");
  const [copied,setCopied]=useState(false)
  const [moveOpen, setMoveOpen] = useState(false);
  

  const handleRename = async () => {
    setRenameOn("flex");
  };

  const updateFileSchema = Yup.object().shape({
    name: Yup.string().required("Name of file is required."),
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FILE,
    item: { id: file.id, name: file.name },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });
  const handleCopyUrl = async () => {
    try {
      // Get the absolute current window URL
      const currentUrl = window.location.href;

      // Write the URL string to the clipboard
      await navigator.clipboard.writeText(currentUrl);

      // Update state to show feedback
      setCopied(true);
      // Show snackbar to notify user
      disptach(showSnackbar("Link copied to clipboard", "success"));
      // Reset feedback text after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy URL: ', err);
      disptach(showSnackbar("Failed to copy link", "error"));
    }
  };

  const fileIcon = useMemo(
    () => getFileIcon(file?.name, file?.url),
    [file?.name, file?.url]
  );

  return (
    <div
      ref={drag}
      className="fm-row"
      style={{ opacity: isDragging ? 0.5 : 1 }}
    >
      <Box className="file">
        <div className="w-100 d-flex">
          <div className="filename-icon" style={{ width: "25px", height: "25px" }}>
            {/* <img
              src="/assest/folderpng/excel.png"
              alt="file icon"
              className="w-100 h-100"
            ></img> */}
            <img src={fileIcon} alt="file icon" style={{ width: "20px", height: "20px" }} className="file-icon" />
          </div>
          <div className="file-name px-2 w-100">
            <Typography
              sx={{ display: renameOn === "none" ? "flex" : "none" }}
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W500}
              fontSize={fontSize.h3.medium}
            >
              {file.name}
            </Typography>
          
            <Box
              sx={{ display: renameOn === "none" ? "none" : "flex" }}
              className="w-100"
            >
              <Formik
                initialValues={{
                  name: file ? file.name : "",
                }}
                validationSchema={updateFileSchema}
                className="w-100"
                onSubmit={async (values) => {
                  //(values, "agent payload");
                  await UpdateFileService(values, file.id)
                    .then((res) => {
                      //(res);
                      if (res.status === 200) {
                        //(res);
                        handleFolderActionFromChild();

                        disptach(showSnackbar(res.data.message, "success"));
                        setRenameOn("none");
                      }
                    })
                    .catch((e) => {
                      disptach(showSnackbar(apiErrorMessage(e), "error"));
                    });
                }}
              >
                {({
                  values,
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  handleSubmit,
                  setFieldValue,
                  resetForm,
                }) => (
                  <Form className="w-100" onSubmit={handleSubmit}>
                    <Grid container spacing={2} className="">
                      <Grid item lg={6} xs={6}>
                        <div className="">
                          <OutlinedInputField
                            value={values.name}
                            name={"name"}
                            onChange={handleChange}
                            placeholder="Update file name"
                            fullWidth={true}
                            onBlur={handleBlur}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.name}
                              </Typography>
                            }
                          />
                        </div>
                      </Grid> 
                      <Grid item lg={6} xs={6}>
                        <Box
                          sx={{
                            flexDirection: {
                              lg: "row",
                              md: "row",
                              sm: "column",
                              xs: "column",
                            },
                          }}
                          className=""
                        >
                          <IconButton type="submit">
                            <Check sx={{ fill: ThemeColor.BLUE }} />
                          </IconButton>
                          <IconButton>
                            <Close
                              sx={{ fill: "red" }}
                              onClick={() => {
                                setRenameOn("none");
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Box>
            
          </div>
        </div>
      </Box>
     


      <Box className="file-action">
        <div className="w-100 d-flex align-items-center justify-content-end">
          <div className="file-action-content d-flex">
            <div className="px-2 fm-menu-btn" title="More options">
              <IconButton
                sx={{ padding: 0 }}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <FolderMenu />
              </IconButton>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem onClick={handleRename}>Rename</MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    setMoveOpen(true);
                  }}
                >
                  Move to...
                </MenuItem>
                <MenuItem onClick={() => handleDelete("file", file.id)}>
                  Delete
                </MenuItem>
              </Menu>
              <MoveToModal
                open={moveOpen}
                handleClose={() => setMoveOpen(false)}
                item={{ id: file.id, name: file.name, type: "file" }}
                onMoved={handleFolderActionFromChild}
              />
            </div>
            <div className="px-2" title="Preview">
              <IconButton
                sx={{ padding: 0 }}
                onClick={() => {
                  window.open(file.url, "_blank", "noopener noreferrer");
                  // window.location.href = `${file.url}`;
                }}
              >
                <VisibilityIcon />
              </IconButton>
            </div>
            <div className="px-2">
              <IconButton
                sx={{ padding: 0 }}
                title="Download"
                onClick={() => downloadFile(file, disptach)}
              >
                <FileDownloadIcon />
              </IconButton>
            </div>

          </div>

          <div className="file-action-date d-flex">
            <Typography
              fontFamily={FontFamily.Poppins}
              fontSize={fontSize.h3.small}
              fontWeight={fontWeight.W500}
              color={ThemeColor.GREY}
            >
              {/* Creation date of this file, not today. */}
              {file.createdAt
                ? dayjs(file.createdAt).format("DD/MM/YYYY")
                : "-"}
            </Typography>
          </div>
        </div>
      </Box>
    </div>
  );
};

// Main Folder Management component
const FolderManagement = (props) => {
  const disptach = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [createFolderModal, setCreateFolderModal] = useState(false);
  const [createFileModal, setCreateFileModal] = useState(false);

  const [ConfirmationOpen, setConfirmationOpen] = useState(false);

  const [TypeOfdelete, setTypeOfdelete] = useState("");

  const [deleteId, setDeleteId] = useState();

  const [breadcrumbStack, setBreadcrumbStack] = useState(location.state?.breadcrumbStack || []);

  const handleCloseFileModal = () => {
    setCreateFileModal(!createFileModal);
  };

  const handleDelete = (type, deleteid) => {
    //(deleteid)
    setDeleteId(deleteid);
    setTypeOfdelete(type);
    setConfirmationOpen(true);
  };

  const [folders, setFolders] = useState([
    // {
    //   id: 1,
    //   name: "Folder 1",
    //   files: [{ id: 1, name: "File A" }],
    //   subfolders: [],
    // },
    // {
    //   id: 2,
    //   name: "Folder 2",
    //   files: [{ id: 2, name: "File B" }],
    //   subfolders: [],
    // },
  ]);

  const handleFolderActionFromChild = () => {
    setFolders([]);
    setFiles([]);
    //("calling disptach");
    disptach(GetFolderAction());
  };

  const [files, setFiles] = useState([
    // { id: 3, name: "File C" },
    // { id: 4, name: "File D" },
  ]);

  const [selectedFolder, setSelectedFolder] = useState(null);
  const isAdmin = window?.sessionStorage.getItem("user_role_type") === "admin";

  useEffect(() => {
    setFolders([]);
    setFiles([]);
    disptach(GetFolderAction());
  }, [props]);

  const FolderSelector = useSelector(
    (state) => state.fileManager?.folder?.data?.data
  );

  useEffect(() => {
    const isAdmin =
      window?.sessionStorage.getItem("user_role_type") === "admin";
    FolderSelector?.map((data) => {
      //(data);
      // Locked folders/files are visible to admin only
      if (data.isLocked && !isAdmin) return;
      if (data.type === "folder") {
        let json = {
          id: data._id,
          name: data.name,
          files: data.files,
          subfolders: data.children,
          isLocked: data.isLocked,
          createdAt: data.createdAt,
        };
        const isDuplicateFolder = folders.some(
          (item) => item.id === data._id && item.name === data.name
        );
        if (!isDuplicateFolder) setFolders((prevFiles) => [...prevFiles, json]);
      } else {
        let json = {
          id: data._id,
          name: data.name,
          url: data.url,
          isLocked: data.isLocked,
          createdAt: data.createdAt,
        };
        const isDuplicateFiles = files.some(
          (item) => item.id === data._id && item.name === data.name
        );
        if (!isDuplicateFiles) setFiles((prevFiles) => [...prevFiles, json]);
      }
    });
  }, [FolderSelector]);

  // Handle file drop into a folder
  const handleDrop = async (file, folderId) => {
    //("handle drop", file, folderId);
    let data = {
      name: file.name,
      folder: folderId,
    };

    await UpdateFileService(data, file.id)
      .then((res) => {
        if (res.status === 200) {
          disptach(GetFolderAction());
          disptach(showSnackbar(res.data.message, "success"));
        }
      })
      .catch((e) => {
        disptach(showSnackbar(apiErrorMessage(e), "error"));
      });
  };

  // Handle moving a folder into another folder
  const moveFolder = async (sourceFolderId, destinationFolderId) => {

    const sourceFolder = folders.find((folder) => folder.id === sourceFolderId);


    let data = {
      name: sourceFolder.name,
      parent: destinationFolderId,
    };

    await UpdateFolderService(data, sourceFolderId)
      .then((res) => {
        if (res.status === 200) {
          disptach(GetFolderAction());
          disptach(showSnackbar(res.data.message, "success"));
        }
      })
      .catch((e) => {
        disptach(showSnackbar(apiErrorMessage(e), "error"));
      });

    // Remove the source folder from the main folder list
    setFolders((prevFolders) =>
      prevFolders
        .filter((folder) => folder.id !== sourceFolderId) // Remove the folder from the main list
        .map((folder) =>
          folder.id === destinationFolderId
            ? { ...folder, subfolders: [...folder.subfolders, sourceFolder] }
            : folder
        )
    );
  };

  // Handle folder click to display its files and subfolders
  const handleFolderClick = (folder) => {
    if (folder.isLocked && !isAdmin) {
      disptach(
        showSnackbar(
          "This folder is locked right now by admin please contact to admin",
          "error"
        )
      );
      return;
    }
    const newStack = [...breadcrumbStack, { id: folder.id, name: folder.name }];
    navigate(`Folder/${folder.id}`, {
      state: { breadcrumbStack: newStack }
    });
  };

  const handleBreadcrumbNavigate = (index) => {
    if (index === -1) {
      // Back to root — no folder id needed, just go back N steps
      navigate(-breadcrumbStack.length);
    } else {
      const targetCrumb = breadcrumbStack[index];
      const newStack = breadcrumbStack.slice(0, index + 1);
      const stepsBack = breadcrumbStack.length - 1 - index;
      // Navigate back in history so the URL matches the crumb's folder
      navigate(-stepsBack);
      // Note: the stack is already correct in history state from when we first navigated there
    }
  };

  const {
    search,
    setSearch,
    isSearching,
    filteredFolders,
    filteredFiles,
    resultCount,
  } = useFileManagerSearch(folders, files);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "space-between",
          gap: { xs: 1.5, md: 2 },
          mb: { xs: 2, md: 2.5 },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <FolderBreadcrumbs
            stack={breadcrumbStack}
            onBack={() => navigate(-1)}
            onNavigate={(crumb, index) => handleBreadcrumbNavigate(index)}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: { xs: "stretch", md: "flex-end" },
            gap: 1.5,
            flexShrink: 0,
            "& .MuiButton-root": {
              width: { xs: "100%", sm: "auto" },
              whiteSpace: "nowrap",
              textTransform: "none",
              borderRadius: "10px",
              px: 2,
              py: 0.75,
              fontSize: fontSize.h4.large,
              fontWeight: fontWeight.W600,
            },
          }}
        >
          <FileManagerSearch
            value={search}
            onChange={setSearch}
            isSearching={isSearching}
          />

          <Button
            variant="outlined"
            onClick={() => setCreateFolderModal(true)}
            startIcon={<AddCircleOutlined />}
            sx={{
              color: ThemeColor.YELLOW,
              borderColor: ThemeColor.YELLOW,
              "&:hover": {
                borderColor: ThemeColor.YELLOW,
                backgroundColor: "rgba(252, 191, 1, 0.08)",
              },
            }}
          >
            Create Folder
          </Button>

          <Button
            variant="outlined"
            onClick={() => handleCloseFileModal(true)}
            startIcon={<AddCircleOutlined />}
            sx={{
              color: ThemeColor.PURPLE,
              borderColor: ThemeColor.PURPLE,
              "&:hover": {
                borderColor: ThemeColor.PURPLE,
                backgroundColor: "rgba(21, 83, 158, 0.08)",
              },
            }}
          >
            Create File
          </Button>
        </Box>
      </Box>

      {/* drang n drop container */}
      <div className="container-filemanager">
        <DndProvider backend={HTML5Backend} className="w-100">
          <List
            sx={{ width: "100%", maxWidth: "100%" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          
          >
            {filteredFolders?.map((folder) => (
              <Folder
                key={folder.id}
                folder={folder}
                onDrop={handleDrop}
                moveFolder={moveFolder}
                onClick={handleFolderClick}
                handleFolderActionFromChild={handleFolderActionFromChild}
                handleDelete={handleDelete}
              />
            ))}
          </List>
          <List
            sx={{ width: "100%", maxWidth: "100%" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
         
          >
            {filteredFiles?.map((file) => (
              <ListItem key={file.id} disablePadding sx={{ padding: 0 }}>
                <File
                  key={file.id}
                  file={file}
                  handleFolderActionFromChild={handleFolderActionFromChild}
                  handleDelete={handleDelete}
                />
              </ListItem>
            ))}
          </List>

          {isSearching && resultCount === 0 && (
            <FileManagerNoResult search={search.trim()} />
          )}
        </DndProvider>

        {/* modal for chat window */}
        <Modal
          open={createFolderModal}
          onClose={() => setCreateFolderModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                mb: 2.5,
              }}
            >
              <Typography
                fontFamily={FontFamily.Poppins}
                fontWeight={fontWeight.W600}
                fontSize={fontSize.h3.large}
                color={ThemeColor.BLACK}
              >
                Create Folder
              </Typography>
              <IconButton
                size="small"
                onClick={() => setCreateFolderModal(false)}
                sx={{ color: "#667085" }}
              >
                <Close fontSize="small" />
              </IconButton>
            </Box>
            <Formik
              initialValues={{
                name: "",
              }}
              // validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                //("FOLDER data:", values);

                await CreateFolderService(values)
                  .then((res) => {
                    if (res.status === 200) {
                      // //(res);
                      disptach(GetFolderAction());
                      setCreateFolderModal(false);

                      disptach(showSnackbar(res.data.message, "success"));
                      // navigate("/CAE/Filemanager");
                      resetForm();
                    }
                  })
                  .catch((e) => {
                    disptach(showSnackbar(apiErrorMessage(e), "error"));
                  });
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string().required(
                  "Name of folder is must to create..."
                ),
              })}
            >
              {({
                values,
                errors,
                handleBlur,
                handleChange,
                touched,
                handleSubmit,
                setFieldValue,
              }) => (
                <Form className="w-100">
                  <FormGroup>
                    <OutlinedInputField
                      value={values.name}
                      name={"name"}
                      onChange={handleChange}
                      placeholder="Folder Name...."
                      fullWidth={true}
                      helperText={
                        <Typography
                          align="left"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.name}
                        </Typography>
                      }
                    />
                  </FormGroup>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column-reverse", sm: "row" },
                      justifyContent: "flex-end",
                      gap: 1.5,
                      mt: 3,
                      "& .MuiButton-root": {
                        width: { xs: "100%", sm: "auto" },
                      },
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => setCreateFolderModal(false)}
                      sx={{
                        textTransform: "none",
                        borderRadius: "10px",
                        color: "#667085",
                        borderColor: "#d0d5dd",
                        "&:hover": {
                          borderColor: "#98a2b3",
                          backgroundColor: "#f9fafb",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                    >
                      Create
                    </CustomButton>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>

        <ConfirmationModal
          handleConfirmationClose={() => {
            setConfirmationOpen(false);
          }}
          deletefunction={async () => {
            try {
              const res =
                TypeOfdelete === "file"
                  ? await DeleteFileService(deleteId)
                  : await DeleteFolderService({ folderId: deleteId });
              if (res.status === 200) {
                handleFolderActionFromChild(); // Dispatch the action if success
                return res; // Return the result so the child can access it
              } else {
                return Promise.reject("Unexpected response status"); // Handle unexpected status codes
              }
            } catch (e) {
              disptach(
                showSnackbar(
                  e.response?.data?.message || "Error occurred",
                  "error"
                )
              );
              return e; // Return the error to the child if needed
            }
          }}
          confirmationopen={ConfirmationOpen}
          message={
            TypeOfdelete === "file"
              ? "All deleted files is never been retrievable"
              : "This folder and everything inside it will be permanently deleted."
          }
        />

        <CreateFileModal
          handleClose={handleCloseFileModal}
          createFileModal={createFileModal}
        />
      </div>
    </>
  );
};

function FileManagement() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<FolderManagement />} />
    </div>
  );
}

export default FileManagement;
